import React, { useEffect, useState } from "react";
import { Accordion, Card, Form, Dropdown } from "react-bootstrap";
import Select from "react-select";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import MonthPickerInput from "react-month-picker-input";
import "react-month-picker-input/dist/react-month-picker-input.css";

import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
import "react-calendar/dist/Calendar.css";

import originalMoment from "moment";
import { extendMoment } from "moment-range";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import API from "../services";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export default function SidebarContent(props) {
  const [periodType, setPeriodType] = useState("Quaterly");
  // console.log(props);
  const date = new Date();
  const currentYear = date.getFullYear().toString();
  const moment = extendMoment(originalMoment);
  const [currentOrg, setCurrentOrg] = useState();
  const [countryOrg, setCountryOrg] = useState([
    { displayName: "Select ", id: null },
  ]);
  const [provinceOrg, setProvinceOrg] = useState([
    { displayName: "Select Province", id: null },
  ]);
  const [districtOrg, setDistrictOrg] = useState([
    { displayName: "Select District", id: null },
  ]);
  const [blockOrg, setBlockOrg] = useState([
    { displayName: "Select Block", id: null },
  ]);
  const [facilityOrg, setFacilityOrg] = useState([
    { displayName: "Select Facility", id: null },
  ]);
  const [currentPeriod, setCurrentPeriod] = useState(periodType == "Yearly" ?  "2022" : "2022Q1");
  const [currentQuarter,setcurrentQuarter] = useState("2022")
  const [selectedYear, setSelectedYear] = useState("2022")
  const countryListFilter = [
    {
      // id: sessionStorage.getItem("userData")
      //   ? JSON.parse(sessionStorage.getItem("userData")).organisationUnits[33].id
      //   : "RMxMW3ovfVK",
      // label: sessionStorage.getItem("userData")
      //   ? JSON.parse(sessionStorage.getItem("userData")).organisationUnits[33]
      //       .displayName
      //   : "Alpha",
      // value: sessionStorage.getItem("userData")
      //   ? JSON.parse(sessionStorage.getItem("userData")).organisationUnits[33]
      //       .displayName
      //   : "Alpha",
      // we have integrate hardciode org bcoz the organisationunits[33]is not coming with excat sequence
      id: "RMxMW3ovfVK",
      label: "Alpha",
      value: "Alpha",
    },
  ];
  const [update, setUpdate] = useState(0);
  const [provinceList, setProvinceList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [blocksList, setBlocksList] = useState([]);
  const [facilityList, setFacilityList] = useState([]);
  
  const [dateRange, setDateRange] = useState(new Date());
  const [periodName, setPeriodName] = useState();
  const [selectedQuarter, setSelectedQuarter] = useState(currentYear+"Q1");

  const closeSidebar = () => {
    // console.log(props)
    props.closeSidebar();
    
  };

  useEffect(() => {
    setCurrentPeriod( "2022Q1");
  }, [periodType]);

  const applyFilter = () => {
    let tempOrg = [];

    if (facilityOrg) {
      tempOrg = [
        ...countryOrg,
        ...provinceOrg,
        ...districtOrg,
        ...blockOrg,
        ...facilityOrg,
      ];
    } else if (blockOrg) {
      tempOrg = [...countryOrg, ...provinceOrg, ...districtOrg, ...blockOrg];
    } else if (districtOrg) {
      tempOrg = [...countryOrg, ...provinceOrg, ...districtOrg];
    } else if (provinceOrg) {
      tempOrg = [...countryOrg, ...provinceOrg];
    } else if (countryOrg) {
      tempOrg = [...countryOrg];
    }

    // console.log(tempOrg);

    if (tempOrg.length > 0) {
      setCurrentOrg(tempOrg);
      // console.log(periodName);
      props.applyFilter(tempOrg, currentPeriod, periodName, periodType);
    }
  };

  const resetFilter = () => {
    setProvinceList([]);
    setDistrictList([]);
    setBlocksList([]);
    setFacilityList([]);
    setPeriodName("");
    setPeriodType("Quaterly");
    setUpdate(Math.random());
    if (props.filterFlag) props.resetFilter();
    props.applyFilter(countryOrg, props.latestPeriod, periodName, periodType);
  };

  const selectCountryValue = (orgID, orgName) => {
    // console.log(orgID);

    let tempOrg = [{ displayName: orgName, id: orgID }];

    setCountryOrg(tempOrg);
    setProvinceOrg();
    setDistrictOrg();
    setBlockOrg();
    setFacilityOrg();

    let url = `organisationUnits/${orgID}?paging=false&fields=children%5Bid%2CdisplayName~rename(displayName)%2Ccode%2Cchildren%3A%3AisNotEmpty%2Cpath%2Cparent%5D&userDataViewFallback=true`;
    API.get(url)
      .then((r) => {
        // console.log(r.data);

        setProvinceList(r.data.children);
        setDistrictList([]);
        setBlocksList([]);
        setFacilityList([]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const selectProvinceValue = (orgID, orgName) => {
    // console.log(orgID);

    let tempOrg = [{ displayName: orgName, id: orgID }];

    setProvinceOrg(tempOrg);
    setDistrictOrg();
    setBlockOrg();
    setFacilityOrg();

    let url = `organisationUnits/${orgID}?paging=false&fields=children%5Bid%2CdisplayName~rename(displayName)%2Ccode%2Cchildren%3A%3AisNotEmpty%2Cpath%2Cparent%5D&userDataViewFallback=true`;
    API.get(url)
      .then((r) => {
        // console.log(r.data);

        setDistrictList(r.data.children);
        setBlocksList([]);
        setFacilityList([]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const selectDistrictValue = (orgID, orgName) => {
    // console.log(orgID);

    let tempOrg = [{ displayName: orgName, id: orgID }];

    setDistrictOrg(tempOrg);
    setBlockOrg();
    setFacilityOrg();

    let url = `organisationUnits/${orgID}?paging=false&fields=children%5Bid%2CdisplayName~rename(displayName)%2Ccode%2Cchildren%3A%3AisNotEmpty%2Cpath%2Cparent%5D&userDataViewFallback=true`;
    API.get(url)
      .then((r) => {
        // console.log(r.data);

        setBlocksList(r.data.children);
        setFacilityList([]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const selectBlockValue = (orgID, orgName) => {
    // console.log(orgID);

    let tempOrg = [{ displayName: orgName, id: orgID }];

    setBlockOrg(tempOrg);
    setFacilityOrg();

    let url = `organisationUnits/${orgID}?paging=false&fields=children%5Bid%2CdisplayName~rename(displayName)%2Ccode%2Cchildren%3A%3AisNotEmpty%2Cpath%2Cparent%5D&userDataViewFallback=true`;
    API.get(url)
      .then((r) => {
        // console.log(r.data);

        setFacilityList(r.data.children);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const selectFacilityValue = (orgID, orgName) => {
    // console.log(orgID);

    let tempOrg = [{ displayName: orgName, id: orgID }];

    setFacilityOrg(tempOrg);
  };

  const selectPeriodValue = (selectedYear, selectedMonth) => {
    let latestPeriod =
      selectedYear +
      "-" +
      (Number(selectedMonth) + 1 < 10 ? "0" : "") +
      (Number(selectedMonth) + 1);
    // console.log(latestPeriod);
    setCurrentPeriod(latestPeriod);
  };
  const getDatesBetweenDates = (startDate, endDate) => {
    if (startDate == endDate) return startDate.replaceAll("-", "") + ";";
    var listDate = [];
    var dateString = "";
    var startDate = startDate;
    var endDate = endDate;
    var dateMove = new Date(startDate);
    var strDate = startDate;

    while (strDate < endDate) {
      var strDate = dateMove.toISOString().slice(0, 10);
      listDate.push(strDate);
      dateString += strDate.replaceAll("-", "") + ";";
      dateMove.setDate(dateMove.getDate() + 1);
    }
    return dateString;
  };
  const renderPeriodFilter = () => {
    if (periodType == "Monthly") {
      return (
        <div className="mb-3 mt-3">
          <MonthPickerInput
            style={{ color: "#fff" }}
            year={date.getFullYear()}
            month={date.getMonth()}
            closeOnSelect={false}
            onChange={function (maskedValue, selectedYear, selectedMonth) {
              // console.log(selectedMonth)
              selectPeriodValue(selectedYear, Number(selectedMonth));
              setPeriodName(currentPeriod);
            }}
          />
        </div>
      );
    } else if (periodType == "Yearly") {
      return (
        <div className="mb-3 mt-3">
          <Datetime
            value={currentPeriod.includes("Q") ? currentPeriod.slice(0,4) : currentPeriod}
            style={{ color: "#000" }}
            dateFormat="YYYY"
            timeFormat={false}
            onChange={function (selectedYear) {
              // console.log(selectedYear.toString().slice(11,15))
              setCurrentPeriod(
                 selectedYear.toString().slice(11,15)
              );
              setPeriodName('');
            }}
          />
          {/* <YearPicker
            onChange={function (selectedYear) {
              setCurrentPeriod(selectedYear.toString());
              setPeriodName("");
            }}
          /> */}
        </div>
      );
    } else if (periodType == "Quaterly") {
      return (
        <div className="mb-3 periodselectcontainer mt-3">
          <Form>
            <Form.Group controlId="exampleForm.SelectCustom">
            <Datetime
            value={currentQuarter}
            style={{ color: "#000" }}
            dateFormat="YYYY"
            timeFormat={false}
            onChange={function (selectedYear) {
              // console.log(selectedYear.toString().slice(11,15))
              setcurrentQuarter(
                 selectedYear.toString().slice(11,15)
              );
              setCurrentPeriod(currentQuarter + "Q1");
              // setPeriodName('');
            }}
          />
          
              <Form.Control
                as="select"
                value={currentPeriod}
                custom
                style={{ color: "#fff" }}
                onChange={function (value) {
                  // console.log(value.target.options[value.target.selectedIndex].text)
                  setSelectedQuarter(value.target.value);
                  setCurrentPeriod(value.target.value);
                  setPeriodName(value.target.value
                    // value.target.options[value.target.selectedIndex].text
                  );
                }}
              >
                <option value={currentQuarter+"Q1"}>Quarter 1(Jan-Mar)</option>
                <option value={currentQuarter+"Q2"}>Quarter 2(Apr-Jun)</option>
                <option value={currentQuarter+"Q3"}>Quarter 3(Jul-Sep)</option>
                <option value={currentQuarter+"Q4"}>Quarter 4(Oct-Dec)</option>
              </Form.Control>
            </Form.Group>
          </Form>
        </div>
      );
    } else if (periodType == "Daily") {
      return (
        <div className="mb-3 mt-3">
          <DateRangePicker
            className="DateRangePickercss"
            value={dateRange}
            onChange={function (selected) {
              // console.log(selected[0].toISOString().split('T')[0], selected[1].toISOString().split('T')[0])
              setDateRange(selected);
              setPeriodName(
                "" +
                  selected[0].toISOString().split("T")[0] +
                  " to " +
                  selected[1].toISOString().split("T")[0]
              );
              setCurrentPeriod(
                getDatesBetweenDates(
                  selected[0].toISOString().split("T")[0],
                  selected[1].toISOString().split("T")[0]
                )
              );
            }}
            // singleDateRange={true}
          />
        </div>
      );
    }
  };

  const pathname = window.location.pathname;
  // console.log(countryListFilter)

  return (
    <div className="filter-sidebar-content">
      <p className="sidebar-header mb-3">
        Select Filter
        <button
          type="button"
          className="close-sidebar"
          onClick={() => closeSidebar()}
          style={{ width : "30px",borderRadius: "5px",float : "right",paddingLeft : "10px",backgroundColor : "#26a26b",color : "white"}}
        >
        <FontAwesomeIcon className="color-white fs-12px" icon={faTimes} />  
        </button>
      </p>
      {/* {if(window.location.pathname.includes("FacilityChart")){
      }} */}
      {/* {console.log(window.location.pathname)} */}
      <Tab.Container id="left-tabs-example" defaultActiveKey={window.location.pathname.includes("FacilityChart") ? "second" : "first"}>
        {window.location.pathname.includes("FacilityChart") ? 
        <Row>
        <Col sm={12}>
          <Nav variant="pills">
            <Nav.Item>
              <Nav.Link eventKey="first">Organisation Units</Nav.Link>
            </Nav.Item>
            <Nav.Item className="mx-3">
              <Nav.Link eventKey="second"> Period</Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
      </Row> 
      : 
      <Row>
          <Col sm={12}>
            <Nav variant="pills">
              <Nav.Item>
                <Nav.Link eventKey="first">Organisation Units</Nav.Link>
              </Nav.Item>
              {window.location.pathname.includes("home") || window.location.pathname.includes("PatientChart") || window.location.pathname === '/ncddashboardv3/'  ? "" :
              <Nav.Item className="mx-3">
              <Nav.Link eventKey="second"> Period</Nav.Link>
            </Nav.Item>
             }
              
            </Nav>
          </Col>
        </Row>
        }
        
        <Row>
          <Col sm={12}>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <div className="sidebardropdown">
                  <Dropdown className="dropdownset m-0">
                    <Dropdown.Toggle className="dropdownset">
                      {countryOrg[0].displayName}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {countryListFilter.map((org, index) => {
                        return (
                          <Dropdown.Item
                            key={index + "_country"}
                            onClick={() =>
                              selectCountryValue(org.id, org.label)
                            }
                            value={org.id}
                          >
                            {org.label}
                          </Dropdown.Item>
                        );
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                  {provinceList?.length > 0 ? (
                    <Dropdown className="dropdownset m-0">
                      <Dropdown.Toggle className="dropdownset">
                        {provinceOrg?.length > 0
                          ? provinceOrg[0].displayName
                          : "Select"}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {provinceList.map((org, index) => {
                          // console.log(org)
                          return (
                            <Dropdown.Item
                              key={index + "_province"}
                              onClick={() =>
                                selectProvinceValue(org.id, org.displayName)
                              }
                              value={org.id}
                            >
                              {org.displayName}
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    ""
                  )}
                  {districtList?.length > 0 ? (
                    <Dropdown className="dropdownset m-0">
                      <Dropdown.Toggle
                        id="dropdown-basic"
                        className="dropdownset"
                      >
                        {districtOrg?.length > 0
                          ? districtOrg[0].displayName
                          : "Select"}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {districtList.map((org, index) => {
                          // console.log(org)
                          return (
                            <Dropdown.Item
                              key={index + "_district"}
                              onClick={() =>
                                selectDistrictValue(org.id, org.displayName)
                              }
                              value={org.id}
                            >
                              {org.displayName}
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    ""
                  )}
                  {blocksList?.length > 0 ? (
                    <Dropdown className="dropdownset m-0">
                      <Dropdown.Toggle
                        id="dropdown-basic"
                        className="dropdownset"
                      >
                        {blockOrg?.length > 0
                          ? blockOrg[0].displayName
                          : "Select"}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {blocksList.map((org, index) => {
                          // console.log(org)
                          return (
                            <Dropdown.Item
                              key={index + "_block"}
                              onClick={() =>
                                selectBlockValue(org.id, org.displayName)
                              }
                              value={org.id}
                            >
                              {org.displayName}
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    ""
                  )}
                  {facilityList?.length > 0 ? (
                    <Dropdown className="dropdownset m-0">
                      <Dropdown.Toggle
                        id="dropdown-basic"
                        className="dropdownset"
                      >
                        {facilityOrg?.length > 0
                          ? facilityOrg[0].displayName
                          : "Select"}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {facilityList.map((org, index) => {
                          // console.log(org)
                          return (
                            <Dropdown.Item
                              key={index + "_facility"}
                              onClick={() =>
                                selectFacilityValue(org.id, org.displayName)
                              }
                              value={org.id}
                            >
                              {org.displayName}
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    ""
                  )}
                  {/* </Accordion> */}
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                {pathname != "/alerts" ? (
                  <div>
                    <div className="periodselectcontainer">
                      <Form>
                        <Form.Group controlId="exampleForm.SelectCustom mt-2">
                          <Form.Label className="sidebar-header whiteColor">
                            Period Type{" "}
                          </Form.Label>
                          <Form.Control
                            as="select"
                            value={periodType}
                            custom
                            className="mt-2"
                            style={{ color: "#fff" }}
                            onChange={function (value) {
                              setPeriodType(value.target.value);
                            }}
                          >
                            {/* <option style={{ color: "#fff" }} value="Monthly">
                              Monthly
                            </option> */}
                            <option style={{ color: "#fff" }} value="Quaterly">
                              Quarterly
                            </option>
                            {/* <option style={{ color: "#fff" }} value="Yearly">
                              Yearly
                            </option> */}
                          </Form.Control>
                        </Form.Group>
                      </Form>
                    </div>
                    {renderPeriodFilter()}
                  </div>
                ) : (
                  ""
                )}
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>

     
      <div class="mb-3 mt-5 d-flex justify-content-end align-items-center">
        {/* {console.log(facilityOrg,blockOrg)} */}
        {
          // window.location.pathname.includes("FacilityChart") && facilityOrg.id == "null" ?  <button class="btn btn-grey applyfilterbtn" onClick={() => applyFilter()}  disabled >Apply</button> :
          // blockOrg ? <button class="btn btn-grey applyfilterbtn" onClick={() => applyFilter()}    >Apply</button> : 
          <button class="btn btn-grey applyfilterbtn" onClick={() => applyFilter()}   >Apply</button>
            
          
        }
       
        {/* <button class="btn btn-grey resetfilterbtn ml-2"   onClick={() => resetFilter()}>Reset</button> */}
      </div>
    </div>
  );
}
